import gql from 'graphql-tag'

export const famCrosslink = gql`
  fragment famCrosslink on Crosslink {
    title
    type
    image
    url
  }
`
